import { createFileRoute } from '@tanstack/react-router';

import QuoteRequestLineItemsPage from '@/areas/quote-requests/QuoteRequests/QuoteRequestLineItemsPage/QuoteRequestLineItemsPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/negotiations/$negotiationId/_sidebar/quote-requests/line-items')({
    staticData: { access: { permissions: ['view:sourcing'] }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const { negotiationId } = Route.useParams();
    return <QuoteRequestLineItemsPage context={{ type: 'NegotiationV2', id: negotiationId }} />;
}
